import { Input as DefaultInput } from './Input'
import type { InputProps } from './Input'
import { Search } from './Search'
import { Line } from './Line'
import { Textarea } from './Textarea'

type CompoundComponent = React.ExoticComponent<InputProps> & {
  Search: typeof Search
  Line: typeof Line
  Textarea: typeof Textarea
}

const Input = DefaultInput as CompoundComponent

Input.Search = Search
Input.Line = Line
Input.Textarea = Textarea

export { Input }
export type { SearchInputProps } from './Search'
export type { TextareaProps } from './Textarea'
